<template>
  <!-- 管理员新增医疗机构信息 -->
  <div class="main-css">
    <div class="main-box">
      <p class="box-title">{{ $t("institutionalInformation") }}</p>
      <div class="from">
        <!-- 第一行-->
        <div class="from-long-input">
          <div class="long-box">
            <div class="input-title">
              {{ $t("selectMedicalAdministrator") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown @command="handleClick1">
                <span class="el-long-dropdown-link">
                  {{ dropdownOne }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in userTableData"
                    :key="index"
                    :command="index"
                  >
                    >
                    {{ item.userName }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <!-- 第一行 -->
        <div class="from-one-input">
          <div :class="disabled ? 'one-box-disabled ' : 'one-box'">
            <div class="one-box-title">
              {{ $t("institutionName") }}<span>*</span>
            </div>
            <div class="one-input-css">
              <el-input
                v-model="inputData1"
                :placeholder="elInputInstitutionName"
                :disabled="disabled"
                @blur="inputData(1)"
                maxlength="100"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="from-one-input">
          <div :class="disabled ? 'small-box-disabled ' : 'small-box'">
            <div class="small-box-title">
              {{ $t("postCode") }}<span>*</span>
            </div>
            <div class="small-input-css">
              <el-input
                v-model="inputData2"
                :placeholder="elInputZipCode"
                :disabled="disabled"
                @blur="inputData(2)"
                maxlength="20"
              ></el-input>
            </div>
          </div>
          <div class="one-box">
            <div class="one-box-title">{{ $t("location") }}<span>*</span></div>
            <div class="one-input-css">
              <el-input
                v-model="inputData3"
                :placeholder="elInputLocation"
                :disabled="disabled"
                @blur="inputData(3)"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 第三行 -->
        <div class="from-one-input">
          <div :class="disabled ? 'small-box-disabled ' : 'small-box'">
            <div class="small-box-title">
              {{ $t("institutionalAttributes") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ this.op }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in TableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div :class="disabled ? 'one-box-disabled ' : 'one-box'">
            <div class="one-box-title">{{ $t("hpOrSns") }}<span>*</span></div>
            <div class="one-input-css">
              <el-input
                v-model="inputData5"
                :placeholder="elInputHp"
                :disabled="disabled"
                @blur="inputData(4)"
                maxlength="255"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 第四行 -->
        <div class="from-one-input">
          <div :class="disabled ? 'small-box-disabled ' : 'small-box'">
            <div class="small-box-title">
              {{ $t("representativeName") }}<span>*</span>
            </div>
            <div class="small-input-css">
              <el-input
                v-model="inputData6"
                :placeholder="enterRepresentative"
                :disabled="disabled"
                @blur="inputData(5)"
                maxlength="100"
              ></el-input>
            </div>
          </div>
          <div :class="disabled ? 'one-box-disabled ' : 'one-box'">
            <div class="one-box-title">
              {{ $t("institutionalNumber") }}<span>*</span>
            </div>
            <div class="one-input-css">
              <el-input
                v-model="inputData7"
                :placeholder="EnterPhoneNumber"
                :disabled="disabled"
                @blur="inputData(6)"
                maxlength="20"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 第五行 -->
        <div class="from-one-input">
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("registeredCapital") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown
                :disabled="disabled"
                @command="handleCommandCapitalAmount"
              >
                <span class="el-dropdown-link">
                  {{ this.opCapitalAmount
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in capitalAmountTableDate"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("numberStaff") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommandTeacher">
                <span class="el-dropdown-link">
                  {{ this.opTeacher
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in teacherTableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="small-box">
            <div class="small-box-title">
              {{ $t("numberOfBets") }}<span>*</span>
            </div>
            <div class="inline-box-dropdown">
              <el-dropdown :disabled="disabled" @command="handleCommandBed">
                <span class="el-dropdown-link">
                  {{ this.opBed
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in bedTableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <!-- 第六行 -->
        <div class="form-text-area">
          <div :class="disabled ? 'text-area-box-disabled ' : 'text-area-box'">
            <div class="one-box-title">
              {{ $t("institutionalInformationMain") }}<span>*</span>
            </div>
            <div class="text-area-input">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="機関の経緯について機関の経緯について機関の経緯について機関の経緯について方針方針方針方針方針方針特徴についてスローガンなど"
                v-model="textarea"
                :disabled="disabled"
              >
              </el-input>
            </div>
          </div>
        </div>
        <!-- button部分 -->
        <div class="form-button">
          <button @click="insert">{{ $t("signUp") }}</button>
        </div>
        <!-- 头像部分 -->
        <div class="Avatar">
          <div class="Avatar-img" @click="toGetImg" v-if="!imageUrl">
            <p class="Avatar-img-icon">
              <img src="./assets/Image_01.svg" alt="" />
            </p>
            <p class="Avatar-img-title">{{ $t("LogImage") }}</p>
          </div>
          <div class="Avatar-img" @click="toGetImg" v-if="imageUrl">
            <img :src="imageUrl" alt="" class="Avatar-img-main-css" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AES from "../../js/AES";
import {
  addInstitutionInfo,
  addMedicalInstitutionInfo,
  queryEducationUser,
  queryMedicalUser
} from "../../js/api";
import axios from "axios";
export default {
  name: "educationalCertificationAdd",
  components: {},
  data() {
    return {
      op: "",
      opTeacher: "",
      opBed: "",
      opCapitalAmount: "",
      bedTableData: [],
      TableData: [],
      teacherTableData: [],
      capitalAmountTableDate: [],
      searchData: "", //搜索内容
      imageUrl: "", //头像图片地址路径
      inputData1: "", //機関名input
      inputData2: "", //郵便番号input
      inputData3: "", //所在地input
      inputData4: "", //代表者氏名input
      inputData5: "", //機関の電話番号input
      inputData6: "", //HP or SNSinput
      inputData7: "",
      inputData8: "",
      inputData9: "",
      inputData10: "",
      textarea: "", //文本框内容
      disabled: false, //禁用状态
      lodePageData: {}, //上个页面传回的数据
      loadRole: "", //上个页面传回的角色标识
      dropdownOne: "", //教育机关管理员下拉框
      userTableData: [],
      avatarUrl: "",
      capitalAmount: "",
      educationAttributes: "",
      bedNumber: "",
      staffNumber: "",
      language: "",
      userId: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    this.getLanguage();
    this.loadPage();
    this.getbedNumber();
    this.getEducationAttributes();
    this.getstaffNumber();
    this.getCapitalAmount();
    //生命周期，打开页面时调用
    this.onQueryMedicalUser();
  },
  computed: {
    elInputSearch() {
      return this.$t("ifRegisteredEnterName");
    }, //搜索部分的placeholder

    elInputInstitutionName() {
      return this.$t("forNewEnterContents");
    },

    elInputZipCode() {
      return this.$t("enterZipCode");
    },

    elInputLocation() {
      return this.$t("enterAddress");
    },

    elInputHp() {
      return this.$t("homepageEtc");
    },

    enterRepresentative() {
      return this.$t("enterRepresentative");
    },

    EnterPhoneNumber() {
      return this.$t("EnterPhoneNumber");
    },
    clinic() {
      return this.$t("clinic");
    },
    generalHospital() {
      return this.$t("generalHospital");
    },
    communityMedicalHospital() {
      return this.$t("communityMedicalHospital");
    },
    specialFunctionHospital() {
      return this.$t("specialFunctionHospital");
    },
    paidNursingHome() {
      return this.$t("paidNursingHome");
    },
    housingElderly() {
      return this.$t("housingElderly");
    },
    groupHome() {
      return this.$t("groupHome");
    },
    careHouse() {
      return this.$t("careHouse");
    },
    specialElderlyNursing() {
      return this.$t("specialElderlyNursing");
    },
    longTermCare() {
      return this.$t("longTermCare");
    },
    longTermFacility() {
      return this.$t("longTermFacility");
    }
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.loadPage();
        this.getbedNumber();
        this.getEducationAttributes();
        this.getstaffNumber();
        this.getCapitalAmount();
        //生命周期，打开页面时调用
        this.onQueryMedicalUser();
      }
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.capitalAmount = "capitalAmount";
        this.educationAttributes = "educationAttributes";
        this.bedNumber = "bedNumber";
        this.staffNumber = "staffNumber";
      } else {
        this.capitalAmount = "jpcapitalAmount";
        this.educationAttributes = "jpeducationAttributes";
        this.bedNumber = "jpbedNumber";
        this.staffNumber = "jpstaffNumber";
      }
    },
    // input校验
    inputData(num) {
      var vc1 = /^.{1,99}$/;
      var vc2 = /^.{1,19}$/;
      var vc3 = /^.{1,254}$/;
      var vc4 = /^.{1,254}$/;
      var vc5 = /^.{1,99}$/;
      var vc6 = /^.{1,19}$/;

      if (num === 1) {
        if (vc1.test(this.inputData1)) {
        } else {
          this.$message({
            message: this.$t("warningMedicalName"),
            type: "error"
          });
        }
      } else if (num === 2) {
        if (vc2.test(this.inputData2)) {
        } else {
          this.$message({
            message: this.$t("warningMedicalPost"),
            type: "error"
          });
        }
      } else if (num === 3) {
        if (vc3 !== this.inputData3) {
        } else {
          this.$message({
            message: this.$t("warningMedicalLocal"),
            type: "error"
          });
        }
      } else if (num === 4) {
        if (vc4.test(this.inputData5)) {
        } else {
          this.$message({
            message: this.$t("warningMedicalSns"),
            type: "error"
          });
        }
      } else if (num === 5) {
        if (vc5.test(this.inputData5)) {
        } else {
          this.$message({
            message: this.$t("warningMedicalRpName"),
            type: "error"
          });
        }
      } else if (num === 6) {
        if (vc6.test(this.inputData7)) {
        } else {
          this.$message({
            message: this.$t("warningMedicalPhone"),
            type: "error"
          });
        }
      }
    },
    //获取员工数下拉框选项
    getstaffNumber() {
      var that = this;
      var dataItems = "";
      if (that.language === "CN") {
        dataItems = "employeeNumber";
      } else {
        dataItems = "jpemployeeNumber";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.teacherTableData = aesFecInfo.data;
            console.log(that.teacherTableData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //床位下拉框获取
    getbedNumber() {
      var that = this;
      var dataItems = "";
      if (that.language === "CN") {
        dataItems = "bedNumber";
      } else {
        dataItems = "jpbedNumber";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.bedTableData = aesFecInfo.data;
            console.log(that.bedTableData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //机构属性下拉框获取
    getEducationAttributes() {
      var that = this;
      var dataItems = "";
      that.getLanguage();
      if (that.language === "CN") {
        dataItems = "medicalAttributes";
      } else {
        dataItems = "jpmedicalAttributes";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.TableData = aesFecInfo.data;
            console.log(that.TableData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //资本金下拉框获取
    getCapitalAmount() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.capitalAmount
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.capitalAmountTableDate = aesFecInfo.data;
            console.log(that.capitalAmountTableDate);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //床位人数下拉框
    handleCommandBed(e) {
      this.inputData10 = e.code;
      this.opBed = e.name;
      console.log(e);
    },
    //老师下拉框
    handleCommandTeacher(e) {
      this.inputData9 = e.code;
      this.opTeacher = e.name;
      console.log(e);
    },
    //机关属性下拉框
    handleCommand(e) {
      this.inputData4 = e.code;
      this.op = e.name;
      console.log(e);
    },
    //资本金下拉框
    handleCommandCapitalAmount(e) {
      this.inputData8 = e.code;
      this.opCapitalAmount = e.name;
      console.log(e);
    },
    //新增
    insert() {
      if (
        this.inputData2 !== "" &&
        this.inputData3 !== "" &&
        this.inputData4 !== "" &&
        this.inputData5 !== "" &&
        this.inputData6 !== "" &&
        this.inputData7 !== "" &&
        this.inputData8 !== "" &&
        this.inputData1 !== "" &&
        this.inputData9 !== "" &&
        this.textarea !== "" &&
        this.inputData10 !== ""
      ) {
        var institutionInfoDTO = {
          address: this.inputData3,
          attributes: this.inputData4,
          avatarAddress: this.avatarUrl,
          bedNumber: this.inputData10,
          // bedNumber: 100,
          capitalAmount: this.inputData8,
          // capitalAmount: 100,
          certifiyStatus: 0,
          employeeNumber: this.inputData9,
          // employeeNumber: 100,

          hpOrSns: this.inputData5,
          introduction: this.textarea,
          legalPerson: this.inputData6,
          medicalName: this.inputData1,
          postNumber: this.inputData2,
          status: 0,
          telephone: this.inputData7,
          userId: this.userId,
          userName: this.dropdownOne
        };
        addMedicalInstitutionInfo(institutionInfoDTO)
          .then(res => {
            console.log(institutionInfoDTO);
            if (res.data.code === "A0000") {
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              console.log(aesFecInfo);
              this.$message({
                message: this.$t("addedSuccessfully"),
                type: "success"
              });
              this.$router.push({
                path: "/administratorsViewMedicalList"
              });
            } else {
              console.log(res);
              this.$router.push({
                // path: "/educationAuditFailure",
                query: {
                  message: res.data.message
                }
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.$message({
          message: this.$t("dataEmpty"),
          type: "error"
        });
      }
    },
    //页面加载
    loadPage() {
      var loadData = this.$route.query;
      console.log(loadData);
      if (loadData.rowData === undefined) {
        this.lodePageData = "";
        this.loadRole = "";
        this.disabled = false;
      } else {
        this.lodePageData = loadData.rowData;
        this.loadRole = loadData.role;
        this.disabled = true;
      }
    },
    //机关搜索
    handleSearch() {
      this.$router.push({
        path: "/educationalCertificationTable",
        query: { searchData: this.inputData1 }
      });
    },

    handleClick1(command) {
      // this.$message("click on item" + command);
      this.dropdownOne = this.userTableData[command].userName;
      // this.$message("click on item" + this.dropdownOne);
      this.userId = this.userTableData[command].userId;
      // this.$message("user id is" + this.userId);
    },
    // 查询所有未绑定医疗机构的用户 list
    onQueryMedicalUser() {
      const fakeInfo = {};
      queryMedicalUser(fakeInfo)
        .then(res => {
          console.log("---查询所有未绑定教育机构的用户列表信息----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.userTableData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("----查询所有未绑定教育机构的用户列表信息失败----");
          console.log(res);
        });
    },

    //上传图片
    toGetImg() {
      let inputElement = null;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }
        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 2;
        const size = files.size / 1024 / 1024;
        console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$message.error(this.$t("imageSize"));
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$message.error(this.$t("selectImage"));
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.imageUrl = this.result;
            console.log(this.result);
            // 数据传到后台
            const formData = new FormData();
            formData.append("file", files); // 可以传到后台的数据
            console.log(formData.get("file"));
            axios
              .post("/api/modules-parent/upload/uploadPictureToOSS", formData, {
                headers: {
                  //头部参数
                  "Content-Type": "multipart/form-data",
                  token: localStorage.getItem("token")
                }
              })
              .then(function(res) {
                //请求成功
                if (res.data.code === "200 OK") {
                  console.log("-----上传图片参数-----");
                  console.log(res);
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                  console.log(aesFecInfo);
                  that.avatar = aesFecInfo.path;
                  that.avatarUrl = aesFecInfo.url;
                  console.log(that.avatar);
                  console.log(that.avatarUrl);
                }
              })
              .catch(function(error) {
                //请求失败
                console.log(error);
              });
          };
        }
      }
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 35px 0;
  box-sizing: border-box;
}
.main-box {
  /* height: 100%; */
  width: 700px;
  margin: auto;
  position: relative;
}

.from-long-input {
  height: 50px;
  padding: 0 0 0 40px;
  box-sizing: border-box;
  margin-top: 20px;
  display: flex;
}

.box-title {
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  height: 34px;
  color: #686868;
  text-align: center;
  margin-bottom: 12px;
}
.search {
  height: 35px;
  padding: 0 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}
.search /deep/ .el-input {
  width: 313px;
  height: 30px;
}
.search /deep/ .el-input__inner {
  width: 313px;
  height: 30px;
}
.search /deep/ .el-input__icon {
  line-height: 30px;
}
.search button {
  width: 85px;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 15px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
}
.from-one-input {
  height: 50px;
  padding: 0 0 0 40px;
  box-sizing: border-box;
  margin-top: 20px;
  display: flex;
}
.one-box {
  width: 416px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.one-box-disabled {
  width: 416px;
  height: 44px;
  background-color: #f5f7fa;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.one-box-title {
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  box-sizing: border-box;
  position: absolute;
  top: -12px;
  left: 15px;
  background: #fff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
  z-index: 20;
}
.one-box-title span {
  color: #da1414;
}
.one-input-css /deep/ .el-input {
  width: 400px;
  height: 40px;
  margin-left: 5px;
}
.one-input-css /deep/ .el-input__inner {
  border: 1px solid transparent;
}
.small-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 20px;
}
.small-box-disabled {
  width: 200px;
  height: 44px;
  background-color: #f5f7fa;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 20px;
}
.small-box-title {
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  box-sizing: border-box;
  position: absolute;
  top: -12px;
  left: 15px;
  background: #fff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
  z-index: 20;
}
.small-box-title span {
  color: #da1414;
}
.small-input-css /deep/ .el-input {
  width: 180px;
  height: 40px;
  /* margin-left: 5px; */
}
.small-input-css /deep/ .el-input__inner {
  border: 1px solid transparent;
}
.inline-box-dropdown {
  height: 40px;
  line-height: 45px;
  overflow: hidden;
}
.el-dropdown-link {
  width: 180px;
  display: inline-block;
  padding: 0 0 0 15px;
  box-sizing: border-box;
}
.inline-box-dropdown i {
  float: right;
  margin-top: 15px;
  font-weight: 700;
}
.form-text-area {
  height: 178px;
  padding: 0 0 0 40px;
  box-sizing: border-box;
  margin-top: 20px;
}
.text-area-box {
  width: 640px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.text-area-box-disabled {
  width: 640px;
  height: 178px;
  background-color: #f5f7fa;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.text-area-input {
  margin-top: 10px;
}
.text-area-input /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  height: 160px;
}
.form-button {
  text-align: center;
  margin-top: 37px;
}
.form-button button {
  height: 40px;
  line-height: 40px;
  width: 150px;
  background: #fc630c;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.long-box {
  width: 640px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.Avatar {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 95px;
  right: 75px;
}
.Avatar-img {
  width: 90px;
  height: 90px;
  background: #51abff;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
}
.Avatar-img-icon {
  margin-top: 15px;
}
.Avatar-img-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.Avatar-img .Avatar-img-main-css {
  width: 90px;
  height: 90px;
}

.one-box-disabled .inline-box-dropdown {
  line-height: 44px;
  height: 44px;
  overflow: hidden;
}
.one-box-disabled .el-dropdown-link {
  width: 400px;
  display: inline-block;
  padding: 0 0 0 15px;
  box-sizing: border-box;
}
.one-box-disabled .inline-box-dropdown i {
  float: right;
  margin-top: 15px;
  font-weight: 700;
}

.one-box .inline-box-dropdown {
  line-height: 44px;
  height: 44px;
  overflow: hidden;
}
.one-box .el-dropdown-link {
  width: 400px;
  display: inline-block;
  padding: 0 0 0 15px;
  box-sizing: border-box;
}
.one-box .inline-box-dropdown i {
  float: right;
  margin-top: 15px;
  font-weight: 700;
}
.input-title {
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  box-sizing: border-box;
  position: absolute;
  top: -12px;
  left: 15px;
  background: #fff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
  z-index: 20;
}
.input-title span {
  color: #da1414;
}
.one-input-css /deep/ .el-input {
  width: 400px;
  height: 40px;
  margin-left: 5px;
}
.one-input-css /deep/ .el-input__inner {
  border: 1px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorAddsMedicalInformation/index.vue